import React from 'react'
import { useNavigate } from 'react-router-dom'
import { UNAUTHENTICATED_ROUTES } from '../resources/routes-constants'
import { Box, Button, Typography } from '@mui/material'

import { useTranslation } from 'react-i18next'

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate()
    const { t } = useTranslation();

    /**
     * Call this function to redirect the user to the homepage.
     */
    const redirectToHomePage = () => {
        navigate(UNAUTHENTICATED_ROUTES.HOMEPAGE_ROUTE)
    }

    return (
        <Box display={"flex"} flexDirection={"column"} alignItems={"Center"} justifyContent={"center"} gap={"20px"} flexGrow={1}>
                <Typography variant='h1'>{t('PageTitleNotFound')}</Typography>
                <Typography variant='body1'>{t('NotFoundBody')}</Typography>
                <Button onClick={redirectToHomePage} variant='contained'>{t('BtnGoHome')}</Button>
        </Box>
    )
}

export default NotFoundPage
